import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ChatMessageDto } from 'src/app/data/models/dto/chat-message.dto';

@Component({
  selector: 'app-chat-item-active-ticket',
  templateUrl: './chat-item-active-ticket.component.html',
  styleUrls: ['./chat-item-active-ticket.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatItemActiveTicketComponent implements OnInit {
  @Input() chatMessages: ChatMessageDto[] = [];
  @Input() showArchived: boolean = false;
  @Input() showActiveTickets: boolean = false;

  @Output() showActiveTicketsChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  get hasActiveTicketRooms() {
    return this.chatMessages.some((chat) => {
        return chat.message.activeTicket;
    });
  }

  get numActiveTicketsRooms() {
    return this.chatMessages
      .filter((chat) => chat.message.activeTicket) // Only messages with active tickets
      .length; // Count them
  }

  showActiveTicketsRooms() {
    this.showActiveTicketsChange.emit(true);
  }
}
